import _ from "underscore";
import Translator from "../../utils/translator";
import { Dialog } from "../framework/dialog";
import { IMissingEldElements } from "./hos/transfer";
import template from "./transferDialog.tmpl";

interface ITransferDialogOptions {
    translator: Translator;
    isUserNightMode: boolean;
}

export default class TransferDialog {
    private readonly translator: Translator;
    private readonly isUserNightMode: boolean;
    private dialog: Dialog;

    constructor(options: ITransferDialogOptions) {
        this.translator = options.translator;
        this.isUserNightMode = options.isUserNightMode;
    }

    open(missingEldElements: IMissingEldElements) {
        return new Promise<boolean>(resolve => {
            let missingEldElementsListStr = this.generateMissingEldStr(missingEldElements);
            let templateStr = (_.template(template))({
                missingElements: missingEldElementsListStr
            });

            this.dialog = new Dialog(
                "div",
                templateStr,
                this.translator,
                "Proceed with this issue?",
                [
                    [{
                        text: "Cancel",
                        id: "transfer-eld-cancel",
                        className: "button_secondary",
                        spinner: true,
                        callback: () => resolve(false)
                    }],
                    [{
                        text: "Proceed",
                        id: "transfer-eld-proceed",
                        spinner: true,
                        callback: () => resolve(true)
                    }]
                ],
                { isNightMode: this.isUserNightMode }
            );

            return this.dialog.open().then(() => {
                this.dialog.onRemove(() => {
                    resolve(false);
                });
            });
        });
    }

    close() {
        this.dialog && this.dialog.remove();
    }

    private generateMissingEldStr(missingEldElements: IMissingEldElements) {
        let resultStr = "";
        if (missingEldElements.vinMissing) {
            resultStr += "<li>Missing VIN</li>";
        }

        if (missingEldElements.engineHoursMissing) {
            resultStr += "<li>Missing engine hours</li>";
        }

        if (missingEldElements.distanceMissing) {
            resultStr += "<li>Missing distance</li>";
        }

        if (missingEldElements.powerUnitMissing) {
            resultStr += "<li>Missing power unit</li>";
        }

        if (missingEldElements.activeEngineSync) {
            resultStr += "<li>Active engine sync</li>";
        }

        return resultStr;
    }
}